import { formatMoney } from "~/utils/formatMoney"
import moment from "moment"

const RentRollTable = ({ data, camp }) => {
  return (
    <table className="min-w-full table-auto divide-y divide-gray-300">
      <thead className="sticky top-0 bg-white shadow-sm">
        <tr>
          <th scope="col" className="py-3.5 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Site Name
          </th>
          <th scope="col" className="pl-3 py-3.5 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Camper Name
          </th>
          <th scope="col" className="pl-3 py-3.5 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Lease Start Date
          </th>
          <th scope="col" className="pl-3 py-3.5 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Lease End Date
          </th>
          <th
            scope="col"
            className="pl-3 py-3.5 w-1/12 text-right text-base font-semibold text-gray-900 whitespace-nowrap"
          >
            Monthly Rent
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Electricity Fees
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Other Charges
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Service Fees
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Credit Card Fees
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Taxes
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Total Owed
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Total Paid
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {data &&
          data.map((rentRollData, index) => {
            const {
              site_name,
              camper_name,
              lease_start_date,
              lease_end_date,
              monthly_rent,
              electricity_fees,
              service_fees,
              other_charges,
              credit_card_fees,
              tax_fees,
              total_owed,
              total_paid,
            } = rentRollData

            return (
              <tr className="h-10 hover:bg-gray-50" key={index}>
                <td className="font-medium whitespace-nowrap">{site_name}</td>
                <td className="pl-3 text-gray-500 whitespace-nowrap">{camper_name}</td>
                <td className="pl-3 text-gray-500 whitespace-nowrap">{moment(lease_start_date).format("MM-DD")}</td>
                <td className="pl-3 text-gray-500 whitespace-nowrap">{moment(lease_end_date).format("MM-DD")}</td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(monthly_rent, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(electricity_fees, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(other_charges, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(service_fees, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(credit_card_fees, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(tax_fees, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(total_owed, camp?.currency)}
                </td>
                <td className="pl-3 text-gray-500 whitespace-nowrap text-right">
                  {formatMoney(total_paid, camp?.currency)}
                </td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default RentRollTable
